import {TriangleAlertIcon} from 'lucide-react';
import {Alert, AlertDescription, AlertTitle, Button} from '@tinct/web-components';

interface DeletionAlertProps {
  deleteAt: string;
  isPending: boolean;
  onCancelDeletion: () => void;
}

export function DeletionAlert({deleteAt, isPending, onCancelDeletion}: DeletionAlertProps) {
  return (
    <Alert variant="destructive"
           className="flex items-center gap-3 rounded-2xl border-rose-100 bg-rose-50 p-4 [&>svg]:translate-y-0">
      <TriangleAlertIcon className="size-4 shrink-0"/>
      <div className="flex flex-1 flex-col gap-2">
        <AlertTitle className="truncate text-sm">
          This workspace is scheduled for deletion
        </AlertTitle>
        <AlertDescription className="text-destructive">
          Deletion will occur on{' '}
          {new Date(deleteAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
          . All actions are limited to read-only.
        </AlertDescription>
      </div>
      <Button
        size="sm"
        className="h-6 shrink-0 text-xs"
        disabled={isPending}
        onClick={onCancelDeletion}
      >
        Cancel deletion
      </Button>
    </Alert>
  );
}
